import styled from 'styled-components';

export const Root = styled.div`
    display: grid;
    grid-auto-flow: row;
    gap: 1rem;
`;
